
<!-- 第三种登录方式 -->
<template>
  <div class="third-wrap">
    <img src="@/assets/images/CAimgs.png" class="imgca" @click="doListCert" />

    <embed
      id="JITComVCTKEx"
      type="application/x-jit-sign-vctk-s-plugin-boc"
      width="100"
      height="100"
      style="opacity: 0.1;"
    />
  </div>
</template>
<script>
import * as publicapi from '@/api/public';
export default {
  data() {
    //这里存放数据
    return {
      JITComVCTKEx: '',
    };
  },
  created() {},
  mounted() {
    this.JITComVCTKEx = document.getElementById('JITComVCTKEx');
  },
  methods: {
    doListCert() {
      publicapi.GetOriginal().then((res) => {
        var strRandomNum = res.result;
        var InitParam =
          '<?xml version="1.0" encoding="gb2312"?><authinfo><liblist><lib type="CSP" version="1.0" dllname="" ><algid val="SHA1" sm2_hashalg="sm3"/></lib><lib type="SKF" version="1.1" dllname="SERfR01DQUlTLmRsbA==" ><algid val="SHA1" sm2_hashalg="sm3"/></lib><lib type="SKF" version="1.1" dllname="U2h1dHRsZUNzcDExXzMwMDBHTS5kbGw=" ><algid val="SHA1" sm2_hashalg="sm3"/></lib><lib type="SKF" version="1.1" dllname="U0tGQVBJLmRsbA==" ><algid val="SHA1" sm2_hashalg="sm3"/></lib></liblist></authinfo>';
        JITComVCTKEx.Initialize(InitParam);
        JITComVCTKEx.SetCertChooseType(0);
        JITComVCTKEx.SetCert('SC', '', '', '', '', ''); //启动证书，弹窗

        var temp_DSign_Result = JITComVCTKEx.AttachSignStr('', strRandomNum);

        publicapi
          .SignedOriginal({ signedData: temp_DSign_Result })
          .then((res) => {
            console.log(res.result);
            this.$store.commit('SET_TOKENS', res.result.token);
            this.$store.commit('SET_IDS', res.result.id);
            this.$store.commit('SET_INFOS', res.result);

            JITComVCTKEx.Finalize(); //销掉
            this.$emit('closeAlert', false); //登录弹窗关闭
          });
        JITComVCTKEx.Finalize(); //销掉
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.third-wrap {
  width: 100%;
  text-align: center;
  padding: 20px 0;

  .imgca {
    width: 140px;
    height: 50px;
    margin: 20px 0;
    cursor: pointer;
  }
}
</style>